import React from "react";
import classnames from "classnames";
import "./index.scss";

const cls = "ToggleButton";

export interface IToggleButtonProps {
  className?: string;
  isOpen: boolean;
  onClick?: () => void;
}

/**
 * 开关
 */
export const ToggleButton: React.SFC<IToggleButtonProps> = props => {
  const { isOpen, onClick } = props;
  return (
    <div
      className={classnames(classnames, cls, isOpen && `${cls}--open`)}
      onClick={onClick}
    >
      <em />
      <em />
      <em />
    </div>
  );
};
